import Paper from "@mui/material/Paper";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import TextField from "components/TextFieldInput";
// import Autocomplete from "components/Autocomplete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import {
  StyledTableRow,
  StyledTableRow1,
  StyledTableRow2,
  WorkOrderHeading,
  StyledDisabledByDefaultIcon,
  TextAreaWrapper,
} from "styles/pages/order";
import TagsAutocomplete from "components/TagsAutocomplete";
import { DECORATIONS } from "constants/services";
import CustomAutocomplete from "components/Autocomplete";
// import { useFetch } from "hooks/useFetch";
// import { useEffect, useState } from "react";

const SalesOrderLineItems = ({ state, setState }) => {
  // const [decorations, setDecorations] = useState([]);

  // const { refetch } = useFetch(DECORATIONS, DECORATIONS, {
  //   enabled: false,
  // });

  // useEffect(() => {
  //   const fetchDecorations = async () => {
  //     const { data } = await refetch();
  //     setDecorations(data);
  //   };
  //   fetchDecorations();
  // }, []);

  const lineItems = state?.lineItems;

  const handleLineItemsChange = (key, value, index) => {
    setState({
      ...state,
      lineItems: lineItems?.map((row, j) => {
        if (index !== j) return row;
        return {
          ...row,
          [key]: value,
        };
      }),
    });
  };

  return (
    <Paper elevation={3}>
      <WorkOrderHeading>
        <div>Line Items</div>

        <AddCircleIcon
          sx={{ cursor: "pointer" }}
          onClick={() =>
            setState({
              ...state,
              lineItems: [{ taxPercentage: 13 }, ...lineItems],
            })
          }
        />
      </WorkOrderHeading>
      {lineItems?.map((row, i) => {
        const key = i;
        return (
          <StyledTableRow
            key={`editedLineItems_${key}`}
            even={i % 2 === 0}
            style={{
              borderBottom: "1px dashed #000",
            }}
          >
            <div style={{ position: "relative", height: 40 }}>
              <StyledDisabledByDefaultIcon
                onClick={() =>
                  setState({
                    ...state,
                    lineItems: lineItems?.filter((r, j) => i !== j),
                  })
                }
              />
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ position: "absolute", top: 0, right: 20 }}
                onClick={() => {
                  setState({
                    ...state,
                    lineItems: [{ ...row, taxPercentage: 13 }, ...lineItems],
                  });
                }}
              >
                Clone
              </Button>
            </div>

            <StyledTableRow1>
              <TextField
                label="Description"
                error={!row?.description?.trim()}
                value={row?.description}
                handleChange={(e) =>
                  handleLineItemsChange("description", e?.target?.value, i)
                }
              />
            </StyledTableRow1>

            <StyledTableRow2>
              <TextField
                label="Quantity"
                error={!row?.qty}
                value={row?.qty}
                type="number"
                handleChange={(e) => {
                  const qty = Number(e?.target?.value);
                  const decorationCost = Number(row?.decorationCost) || 0;
                  const taxPercentage = Number(row?.taxPercentage) || 0;
                  const taxCharged =
                    decorationCost * qty * (taxPercentage / 100) || 0;
                  const chargeAmount = decorationCost * qty + taxCharged;
                  setState({
                    ...state,
                    lineItems: lineItems?.map((r, j) => {
                      if (i !== j) return r;
                      return {
                        ...r,
                        decorationCost,
                        taxCharged,
                        chargeAmount,
                        qty,
                      };
                    }),
                  });
                }}
                // handleChange={(e) =>
                //   handleLineItemsChange("qty", Number(e?.target?.value), i)
                // }
              />

              <TextField
                label="Color"
                error={!row?.color?.trim()}
                value={row?.color}
                handleChange={(e) =>
                  handleLineItemsChange("color", e?.target?.value, i)
                }
              />

              {/* <TextField
                label="Size"
                error={!row?.size?.trim()}
                value={row?.size}
                handleChange={(e) =>
                  handleLineItemsChange("size", e?.target?.value, i)
                }
              /> */}

              <CustomAutocomplete
                label="Size"
                value={row?.size}
                setValue={(c) => {
                  handleLineItemsChange("size", c, i);
                }}
                inputValue={row?.sizeInputValue}
                setInputValue={(v) => {
                  handleLineItemsChange("sizeInputValue", v, i);
                }}
                options={[
                  { id: "YXS", label: "YXS" },
                  { id: "YSM", label: "YSM" },
                  { id: "YMD", label: "YMD" },
                  { id: "YLG", label: "YLG" },
                  { id: "YXL", label: "YXL" },
                  { id: "Y2XL", label: "Y2XL" },
                  { id: "Y3XL", label: "Y3XL" },
                  { id: "Y4XL", label: "Y4XL" },
                  { id: "Y5XL", label: "Y5XL" },
                  { id: "AXS", label: "AXS" },
                  { id: "AS", label: "AS" },
                  { id: "AM", label: "AM" },
                  { id: "AL", label: "AL" },
                  { id: "AXL", label: "AXL" },
                  { id: "A2XL", label: "A2XL" },
                  { id: "A3XL", label: "A3XL" },
                  { id: "A4XL", label: "A4XL" },
                  { id: "A5XL", label: "A5XL" },
                  { id: "OSFA", label: "OSFA" },
                ]}
              />

              <TagsAutocomplete
                multiple={false}
                optionApiKey="decoCode"
                apiEndPoint={DECORATIONS}
                value={row?.decoration || { title: "", value: "" }}
                setValue={(decoration) => {
                  handleLineItemsChange(
                    "decoration",
                    {
                      title: decoration?.title || "",
                      value: decoration?.value || "",
                    },
                    i
                  );
                }}
                label="Decorations"
              />

              {/* <Autocomplete
                label="Decoration"
                value={row?.decoration}
                setValue={(c) => handleLineItemsChange("decoration", c, i)}
                inputValue={row?.decorationInput}
                setInputValue={(v) =>
                  handleLineItemsChange("decorationInput", v, i)
                }
                options={
                  decorations?.map((u) => ({
                    ...u,
                    id: u?.decoCode,
                    label: u?.decoCode,
                  })) || []
                }
              /> */}
            </StyledTableRow2>

            <StyledTableRow2>
              <TextField
                label="Purchase Order"
                value={row?.purchaseOrder}
                handleChange={(e) =>
                  handleLineItemsChange("purchaseOrder", e?.target?.value, i)
                }
              />
            </StyledTableRow2>

            <StyledTableRow2>
              <TextAreaWrapper>
                <p>Additional Information</p>
                <TextareaAutosize
                  label="Additional Information"
                  style={{ width: "98%", backgroundColor: "inherit" }}
                  placeholder="Attention Information"
                  minRows={3}
                  value={row?.additionalInformation}
                  onChange={(e) =>
                    handleLineItemsChange(
                      "additionalInformation",
                      e?.target?.value,
                      i
                    )
                  }
                />
              </TextAreaWrapper>
            </StyledTableRow2>

            <StyledTableRow2>
              <TextField
                label="Decoration Cost"
                error={!row?.decorationCost}
                value={row?.decorationCost}
                type="number"
                handleChange={(e) => {
                  const decorationCost = Number(e?.target?.value);
                  const qty = Number(row?.qty);
                  const taxPercentage = Number(row?.taxPercentage) || 0;
                  const taxCharged =
                    decorationCost * qty * (taxPercentage / 100);
                  const chargeAmount = decorationCost * qty + taxCharged;
                  setState({
                    ...state,
                    lineItems: lineItems?.map((r, j) => {
                      if (i !== j) return r;
                      return {
                        ...r,
                        decorationCost,
                        taxCharged,
                        chargeAmount,
                      };
                    }),
                  });
                }}
              />

              <TextField
                label="Tax Percentage"
                error={!row?.taxPercentage}
                value={row?.taxPercentage}
                type="number"
                handleChange={(e) => {
                  const taxPercentage = Number(e.target.value);
                  const decorationCost = Number(row?.decorationCost) || 0;
                  const qty = Number(row?.qty);
                  const taxCharged =
                    decorationCost * qty * (taxPercentage / 100);
                  const chargeAmount = decorationCost * qty + taxCharged;
                  setState({
                    ...state,
                    lineItems: lineItems?.map((r, j) => {
                      if (i !== j) return r;
                      return {
                        ...r,
                        taxPercentage,
                        taxCharged,
                        chargeAmount,
                      };
                    }),
                  });
                }}
              />

              <TextField
                label="Tax Charged"
                disabled
                value={Number(row?.taxCharged).toFixed(2)}
                type="number"
              />

              <TextField
                label="Charge Amount"
                error={!row?.chargeAmount}
                value={Number(row?.chargeAmount).toFixed(2)}
                disabled
              />
            </StyledTableRow2>
          </StyledTableRow>
        );
      })}
    </Paper>
  );
};

SalesOrderLineItems.propTypes = PROP_TYPES;

SalesOrderLineItems.defaultProps = DEFAULT_STATE;

export default SalesOrderLineItems;
